export const PRODUCT_DETAIL = 'productDetail';
export type PRODUCT_DETAIL = typeof PRODUCT_DETAIL;

export const PRODUCT_IMPRESSIONS = 'productImpressions';
export type PRODUCT_IMPRESSIONS = typeof PRODUCT_IMPRESSIONS;

export const PRODUCT_CLICK = 'productClick';
export type PRODUCT_CLICK = typeof PRODUCT_CLICK;

export const MEASURING_PURCHASES = 'measuringPurchases';
export type MEASURING_PURCHASES = typeof MEASURING_PURCHASES;

export const SHOP_BY_CATEGORY = 'rpb2b-react/analytics/SHOP_BY_CATEGORY';
export type SHOP_BY_CATEGORY = typeof SHOP_BY_CATEGORY;

export const PRODUCT_ADD_TO_CART = 'addToCart';
export type PRODUCT_ADD_TO_CART = typeof PRODUCT_ADD_TO_CART;

export const PRODUCT_ADD_SIMPLE_TO_CART =
  'rpb2b-react/analytics/PRODUCT_ADD_SIMPLE_TO_CART';
export type PRODUCT_ADD_SIMPLE_TO_CART = typeof PRODUCT_ADD_SIMPLE_TO_CART;

export const PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE =
  'rpb2b-react/analytics/PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE';
export type PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE = typeof PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE;

export const PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE =
  'rpb2b-react/analytics/PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE';
export type PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE = typeof PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE;

export const PRODUCT_REMOVE_FROM_CART = 'removeFromCart';
export type PRODUCT_REMOVE_FROM_CART = typeof PRODUCT_REMOVE_FROM_CART;

export const PLACE_ORDER_CONFIRMATION =
  'rpb2b-react/analytics/PLACE_ORDER_CONFIRMATION';
export type PLACE_ORDER_CONFIRMATION = typeof PLACE_ORDER_CONFIRMATION;

export const SHOP_BY_CATEGORY_PAGEVIEW = 'shopByCategoryPageView';
export type SHOP_BY_CATEGORY_PAGEVIEW = typeof SHOP_BY_CATEGORY_PAGEVIEW;

export const SEARCH_RESULT_IMPRESSIONS =
  'rpb2b-react/analytics/SEARCH_RESULT_IMPRESSIONS';
export type SEARCH_RESULT_IMPRESSIONS = typeof SEARCH_RESULT_IMPRESSIONS;

export const SEARCH_RESULT_PRODUCT_CLICK =
  'rpb2b-react/analytics/SEARCH_RESULT_PRODUCT_CLICK';
export type SEARCH_RESULT_PRODUCT_CLICK = typeof SEARCH_RESULT_PRODUCT_CLICK;

export const CHECKOUT_STEP = 'rpb2b-react/analytics/CHECKOUT_STEP';
export type CHECKOUT_STEP = typeof CHECKOUT_STEP;

export const CHECKOUT = 'checkout';
export type CHECKOUT = typeof CHECKOUT;

export const SEND_USER_DATA = 'rpb2b-react/analytics/SEND_USER_DATA';
export type SEND_USER_DATA = typeof SEND_USER_DATA;

export const SEND_MODEL_PRODUCT_IMPRESSION =
  'rpb2b-react/analytics/SEND_MODEL_PRODUCT_IMPRESSION';
export type SEND_MODEL_PRODUCT_IMPRESSION = typeof SEND_MODEL_PRODUCT_IMPRESSION;

export const STORE_MODEL_DIAGRAM_PRODUCT_DATA =
  'rpb2b-react/analytics/STORE_MODEL_DIAGRAM_PRODUCT_DATA';
export type STORE_MODEL_DIAGRAM_PRODUCT_DATA = typeof STORE_MODEL_DIAGRAM_PRODUCT_DATA;

export const SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION =
  'rpb2b-react/analytics/SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION';
export type SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION = typeof SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION;

export const MODEL_DIAGRAM_PRODUCT_CLICK =
  'rpb2b-react/analytics/MODEL_DIAGRAM_PRODUCT_CLICK';
export type MODEL_DIAGRAM_PRODUCT_CLICK = typeof MODEL_DIAGRAM_PRODUCT_CLICK;

export const GET_PAYMENT_METHOD_CHECKOUT =
  'rpb2b-react/analytics/GET_PAYMENT_METHOD_CHECKOUT';
export type GET_PAYMENT_METHOD_CHECKOUT = typeof GET_PAYMENT_METHOD_CHECKOUT;

export const PRODUCT_RETURNS = 'refund';
export type PRODUCT_RETURNS = typeof PRODUCT_RETURNS;

export const SELECTED_MODEL_INFORMATION =
  'rpb2b-react/analytics/SELECTED_MODEL_INFORMATION';
export type SELECTED_MODEL_INFORMATION = typeof SELECTED_MODEL_INFORMATION;

export const PRODUCT_UPLOAD_FILE_ADD_TO_CART =
  'rpb2b-react/analytics/PRODUCT_UPLOAD_FILE_ADD_TO_CART';
export type PRODUCT_UPLOAD_FILE_ADD_TO_CART = typeof PRODUCT_UPLOAD_FILE_ADD_TO_CART;

export const CATEGORIES_PRODUCT_CLICK =
  'rpb2b-react/analytics/CATEGORIES_PRODUCT_CLICK';
export type CATEGORIES_PRODUCT_CLICK = typeof CATEGORIES_PRODUCT_CLICK;

export const RMA_RETURNS_INFORMATION =
  'rpb2b-react/analytics/RMA_RETURNS_INFORMATION';
export type RMA_RETURNS_INFORMATION = typeof RMA_RETURNS_INFORMATION;

export const GET_ITEMS_IN_CART_INFO =
  'rpb2b-react/analytics/GET_ITEMS_IN_CART_INFO';
export type GET_ITEMS_IN_CART_INFO = typeof GET_ITEMS_IN_CART_INFO;

export const UPDATE_CART_ITEM_QTY = 'updateCartItemQty';
export type UPDATE_CART_ITEM_QTY = typeof UPDATE_CART_ITEM_QTY;

export const CLEAR_ALL_ITEMS_FROM_CART =
  'rpb2b-react/analytics/CLEAR_ALL_ITEMS_FROM_CART';
export type CLEAR_ALL_ITEMS_FROM_CART = typeof CLEAR_ALL_ITEMS_FROM_CART;

export default {
  PRODUCT_DETAIL,
  PRODUCT_IMPRESSIONS,
  PRODUCT_CLICK,
  MEASURING_PURCHASES,
  SHOP_BY_CATEGORY,
  PLACE_ORDER_CONFIRMATION,
  SHOP_BY_CATEGORY_PAGEVIEW,
  SEARCH_RESULT_IMPRESSIONS,
  SEARCH_RESULT_PRODUCT_CLICK,
  PRODUCT_ADD_TO_CART,
  PRODUCT_ADD_SIMPLE_TO_CART,
  PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE,
  PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE,
  CHECKOUT_STEP,
  CHECKOUT,
  SEND_USER_DATA,
  SEND_MODEL_PRODUCT_IMPRESSION,
  STORE_MODEL_DIAGRAM_PRODUCT_DATA,
  SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION,
  MODEL_DIAGRAM_PRODUCT_CLICK,
  GET_PAYMENT_METHOD_CHECKOUT,
  PRODUCT_RETURNS,
  SELECTED_MODEL_INFORMATION,
  PRODUCT_UPLOAD_FILE_ADD_TO_CART,
  CATEGORIES_PRODUCT_CLICK,
  RMA_RETURNS_INFORMATION,
  GET_ITEMS_IN_CART_INFO,
  UPDATE_CART_ITEM_QTY,
  CLEAR_ALL_ITEMS_FROM_CART
};
